import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.5 6.967c-.105 0-.211.033-.3.1l-8 6c-.221.166-.266.479-.1.7s.479.266.7.101l7.7-5.775 7.7 5.775c.22.165.533.12.7-.101a.5007.5007 0 0 0-.101-.7l-8-6a.503.503 0 0 0-.3-.1z',
  ],
  height: 20,
  width: 20,
});
